import React, { useState } from 'react'
import ourProducts from '../data/ourProducts.json'
import {ourProducts2 as ourProductsSec} from '../data/ourProducts2.js'
import './styles/OurProducts.scss'

import Dropdown from './Dropdown'
import { Link } from 'react-router-dom'

function OurProducts() {
    const [currentCategoryState, setCurrentCategoryState] = useState(ourProducts[0].name)
    const [currentProducts, setCurrentProducts] = useState(ourProducts[0].products)

    function buttonHandler(newName) {
        setCurrentCategoryState(newName)

        const selectedCategory = ourProducts.find((category) => category.name === newName)
        setCurrentProducts(selectedCategory ? selectedCategory.products : [])
    }

    // console.log(currentProducts)

    return (
        <div className="our-products-container block added-border added-border--horizontal added-shadow added-shadow--var2" id="our-products">
            <div className="our-products-container__list">
                {ourProducts.map((el) => (
                    <div key={el.name}>
                        <Link
                            className={el.name === currentCategoryState ? 'main-text--bold' : 'main-text--thin'}
                            to="#"
                            onClick={(evt) => {
                                evt.preventDefault()
                                buttonHandler(el.name)
                            }}
                        >
                            {el.name}
                        </Link>
                    </div>
                ))}
            </div>

            <div className="our-products-container__hr"></div>
            <div>
                {currentProducts.length > 0 ? <Dropdown options={currentProducts.map((el) => el['product-name'])} currentProducts={currentProducts} /> : ''}
            </div>
        </div>
    )
}

export default OurProducts

export const OurProductsSecond = () => {
    const [currentCategoryState, setCurrentCategoryState] = useState(ourProductsSec[0].name)
    const [currentProducts, setCurrentProducts] = useState(ourProductsSec[0].products)

    // console.log(currentCategoryState)

    function buttonHandler(newName) {
        setCurrentCategoryState(newName)

        const selectedCategory = ourProductsSec.find((category) => category.name === newName)
        setCurrentProducts(selectedCategory ? selectedCategory.products : [])
    }

    return (
        <div className="our-products-container block added-border added-border--horizontal added-shadow added-shadow--var2" id="our-products">
            <div className="our-products-container__list">
                {ourProductsSec.map((el) => (
                    <div key={el.name}>
                        <Link
                            className={el.name === currentCategoryState ? 'main-text--bold' : 'main-text--thin'}
                            to="#"
                            onClick={(evt) => {
                                evt.preventDefault()
                                buttonHandler(el.name)
                            }}
                        >
                            {el.name}
                        </Link>
                    </div>
                ))}
            </div>

            <div className="our-products-container__hr"></div>
            <div>
                {currentProducts.length > 0 ? <Dropdown options={currentProducts.map((el) => el['productName'])} currentProducts={currentProducts} /> : ''}
            </div>
        </div>
    )
}
